export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// ./~/d3-color/src/math.js
// module id = 161
// module chunks = 4